import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-all_add",
  "use": "icon-all_add-usage",
  "viewBox": "0 0 12.094 11.969",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12.094 11.969\" id=\"icon-all_add\"><defs><style>#icon-all_add .a{fill:#fff;}</style></defs><path class=\"a\" d=\"M11.531,5.414H6.555V.563a.563.563,0,0,0-1.125,0V5.414H.563a.563.563,0,0,0,0,1.125H5.43v4.867a.563.563,0,0,0,1.125,0V6.539h4.977a.563.563,0,0,0,0-1.125Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol